import { Text, Stack, HStack, Spacer } from '@chakra-ui/react'
import type { FC } from 'react'

import CommentsCount from '../commentsCount'

import useGetObject from '@app/hooks/useGetObject'
import cardFontSize from '@app/shared/cards/cardFontSize'
import { CardAvatar } from '@app/shared/cards/components'
import CardMetricGoals from '@app/shared/cards/metric/cardMetricGoals'
import CardStats from '@app/shared/cards/metric/cardStats'
import type { CardSize, DomainMetric, DomainNode } from '@app/types'

type Props = {
  strategyId: string
  metric: DomainMetric
  node: DomainNode
  size?: CardSize
}

const CollapsedMetric: FC<Props> = ({ strategyId, metric, node, size = 'normal' }) => {
  const { goals, ownerId, commentsCount } = metric
  const owner = useGetObject(ownerId, 'user')
  const goalIds = goals ? goals.map((goal) => goal.id) : []
  const fontSize = cardFontSize('md', size)

  return (
    <Stack>
      <HStack>
        {owner && <CardAvatar user={owner} size={size} />}
        <Text fontSize={fontSize} fontWeight="semibold">
          {metric.name}
        </Text>
        <Spacer />
        <CommentsCount commentsCount={commentsCount} />
      </HStack>
      {goalIds.length > 0 && <CardMetricGoals metric={metric} goalIds={goalIds} size={size} showTitle={false} />}
      <CardStats strategyId={strategyId} metric={metric} node={node} size={size} />
    </Stack>
  )
}

export default CollapsedMetric
